export default __webpack_public_path__ + "static/media/anexe1.88bc3f65.png";